import Chart from 'react-apexcharts';
import { useState, useEffect } from 'react';

export default function Cards(props) {
    const [chartHeight, setChartHeight] = useState(70);

    useEffect(() => {
        const updateHeight = () => {
            const rowVh = window.innerWidth >= 1521 ? 0.20 : 0.17;
            // Altura del cuerpo = altura del row - título (~28px) - padding (~8px)
            const available = Math.floor(window.innerHeight * rowVh) - 36;
            setChartHeight(Math.max(50, available));
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);
    
    const valueNum = Number(props.value);
    const isNegative = Number.isFinite(valueNum) && valueNum < 0;
    const safeValue = Number.isFinite(valueNum) ? valueNum : 0;
    const time = NumToTime(safeValue / 60);

    function NumToTime(num) {
        let hours = Math.floor(num);
        if (hours <= 9) {
            hours = `0${  hours}`;
        }

        let restoHoras = (num % 1) * 100;
        let minutes = Math.round((restoHoras * 60) / 100);
        if (minutes <= 9) {
            minutes = `0${minutes}`;
        }
        return `${hours}:${minutes}`;
    }
    const blanco = 100 - Math.max(0, safeValue);
    const series = [Math.max(0, safeValue), blanco];

    const options = {
        labels: ['OEE', 'blanco'],
        chart: {
            type: 'donut',
            offsetY: 0,
            offsetX: 0,
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 800,
                animateGradually: {
                    enabled: true,
                    delay: 150,
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 500,
                },
            },
        },
        grid: {
            padding: {
                top: -5,
                bottom: -5,
                left: 0,
                right: 0,
            },
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },

        colors: ['#00B884', '#F2F4F8'],
        plotOptions: {
            pie: {
                startAngle: 0,

                expandOnClick: false,

                dataLabels: {
                    offset: 0,
                    minAngleToShowLabel: 10,
                },
                donut: {
                    size: '67%',
                    background: 'transparent',
                    labels: {
                        show: true,
                        name: {
                            show: false,
                        },
                        value: {
                            show: true,
                            fontSize: '16px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            color: undefined,
                            offsetY: 7,
                            formatter: function (val) {
                                return val;
                            },
                        },
                        total: {
                            show: true,
                            showAlways: true,

                            fontSize: '15px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            color: '#373d3f',
                            formatter: function (w) {
                                return `${w.globals.series[0]}%`;
                            },
                        },
                    },
                },
            },
        },
    };

    return (
        <div className="graph">
            <div className="graph-tittle">
                <h3>{props.titulo}</h3>
            </div>
            <div className={`graph-body${props.showcontent && !isNegative ? ' graph-body--visible' : ''}`}>
                <div>
                    <Chart
                        options={options}
                        series={series}
                        type="donut"
                        height={chartHeight}
                    />
                </div>
            </div>
            <div className={`graph-body${!props.showcontent && !isNegative ? ' graph-body--visible' : ''}`}>
                <div className="graph-body-time">
                    <h2 className="graph-body-percen">
                        {time} <br />
                    </h2>
                    <span>{props.tipo}</span>
                </div>
            </div>
            <div className={`graph-body graph-body--calculating${isNegative ? ' graph-body--visible' : ''}`}>
                <div className="graph-body-time">
                    <h2 className="graph-body-percen graph-body-calculating-text">
                        Calculando indicadores
                    </h2>
                </div>
            </div>
        </div>
    );
}
